<template>

    <b-modal id="modal-info-variedad" scrollable centered size="xl" v-model="modalOpened" hide-footer static @shown="modalShown">
        <template v-slot:modal-header>
            <img src="/img/logo_bp.svg" alt="logo_bp.svg" style="width: 165px;margin: auto;">
            <i class="fa fa-times float-right cursor_pointer" style="position: absolute;right: 10px;top: 10px;"
                @click="modalOpened = false"></i>
        </template>
        <div class="d-block">
            <div class="container">
                <product-variety-info-modal v-for="item in variedades" :variedad="item" :key="item.id"
                                            :default-open="item.id===variedad_id" :id="'info-variedad-'+item.id"></product-variety-info-modal>
            </div>
        </div>
    </b-modal>

</template>

<script>
    export default {
        name: "VarietyInfoModal",
        props: ['variedad_id', 'variedades'],
        data() {
            return {
                modalOpened: false
            }
        },
        computed: {
            variedad() {
                this.variedades.find(v => v.id === this.variedad_id);
            }
        },
        watch: {
            variedad_id: function(val) {
                if (val) {
                    this.modalOpened = true;
                }
            },
            modalOpened(val) {
                if (!val) {
                    this.$emit('update:variedad_id', null);
                }
            }
        },
        methods: {
            modalShown() {
                document.getElementById('info-variedad-' + this.variedad_id).scrollIntoView();
            }
        }
    }
</script>

<style>
#modal-info-variedad {
    text-align: left;
}
</style>
